module.exports = __webpack_public_path__ + "img/bg19.683d142b.png";